import React from 'react';
import './App.css';
import { AuthProvider } from './contexts/auth';
import { PermissionsProvider } from './contexts/permissionsContext';
import RouteApp from './routes/routes';

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <PermissionsProvider>
          <RouteApp />
        </PermissionsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
